export enum NoteViewState {
	COLLAPSED = 'COLLAPSED',
	EXPANDED = 'EXPANDED',
	CONTENT_FITS = 'CONTENT_FITS',
}
